export default {
  issues: {
    types: {
      ISSUE_TYPE_EPIC: 'Epic',
      ISSUE_TYPE_STORY: 'Câu chuyện',
      ISSUE_TYPE_TASK: 'Nhiệm vụ',
      ISSUE_TYPE_BUG: 'Lỗi',
      ISSUE_TYPE_SUBTASK: 'Nhiệm vụ con',
    },
    priorities: {
      PRIORITY_HIGHEST: 'Cao nhất',
      PRIORITY_HIGH: 'Cao',
      PRIORITY_MEDIUM: 'Trung bình',
      PRIORITY_LOW: 'Thấp',
      PRIORITY_LOWEST: 'Thấp nhất',
    },
    create: {
      action: 'Tạo nhiệm vụ',
      inColumn: 'Nhiệm vụ',
      title: 'Nhiệm vụ mới',
      type: 'Loại',
      name: 'Tiêu đề',
      namePlaceholder: 'Cần làm gì',
      description: 'Mô tả',
      descriptionPlaceholder: 'Chi tiết, liên kết, tiêu chí hoàn thành',
      priority: 'Độ ưu tiên',
      assignee: 'Người thực hiện',
      assigneePlaceholder: 'Chưa giao',
      noMembers: 'Dự án chưa có thành viên',
      parent: 'Nhiệm vụ cha',
      parentPlaceholder: 'Không có nhiệm vụ cha',
      noParents: 'Không có nhiệm vụ phù hợp',
      dueDate: 'Hạn',
      submit: 'Tạo',
      created: 'Đã tạo nhiệm vụ {key}',
      errors: {
        title: 'Tiêu đề tối đa {limit} ký tự',
        failed: 'Không tạo được nhiệm vụ',
      },
    },
    list: {
      columns: {
        type: 'Loại',
        key: 'Mã',
        title: 'Tiêu đề',
        status: 'Trạng thái',
        priority: 'Ưu tiên',
        assignee: 'Người làm',
        due: 'Hạn',
      },
      groupBy: {
        label: 'Nhóm theo',
        status: 'trạng thái',
        assignee: 'người làm',
        priority: 'ưu tiên',
        type: 'loại',
        none: 'không nhóm',
      },
      select: 'Chọn {key}',
      selectAll: 'Chọn tất cả trên trang',
      selected: 'Đã chọn {count} nhiệm vụ',
      clearSelection: 'Bỏ chọn',
      shown: 'Hiển thị {shown} trong {total}',
      pages: 'Các trang danh sách',
      prev: 'Trang trước',
      next: 'Trang sau',
      changeStatus: 'Đổi trạng thái',
      changeAssignee: 'Đổi người làm',
      assignFailed: 'Không đổi được người làm',
      noAssignee: 'Chưa giao',
      noStatus: 'Chưa có trạng thái',
      noPriority: 'Chưa có ưu tiên',
      noType: 'Chưa có loại',
      empty: {
        title: 'Chưa có nhiệm vụ',
        description: 'Hãy tạo nhiệm vụ đầu tiên — nó sẽ xuất hiện ở đây và trên bảng.',
      },
      error: {
        title: 'Không tải được danh sách',
        description: 'Dịch vụ không phản hồi. Kiểm tra kết nối và thử lại.',
      },
    },
  },
  board: {
    dropHere: 'Thả để chuyển vào đây',
    moveFailed: 'Không chuyển được nhiệm vụ',
    scrollToEnd: 'Đến cột cuối',
    scrollToStart: 'Đến cột đầu',
    nothingFound: {
      title: 'Không tìm thấy gì',
      description: 'Có nhiệm vụ, nhưng không có cái nào khớp bộ lọc. Hãy bỏ lọc hoặc đổi truy vấn.',
    },
    empty: {
      title: 'Bảng đang trống',
      description: 'Hãy tạo nhiệm vụ đầu tiên — hoặc kéo một thẻ từ cột khác vào đây.',
    },
    error: {
      title: 'Không tải được bảng',
      description: 'Dịch vụ không phản hồi. Hãy kiểm tra kết nối và thử lại.',
      retry: 'Thử lại',
    },
  },
  projects: {
    summary: {
      projects: '{count} dự án',
      issues: '{count} công việc đang mở',
      mine: 'bạn tham gia {count}',
    },
    searchPlaceholder: 'Tìm dự án…',
    filters: {
      label: 'Hiển thị dự án nào',
      all: 'Tất cả',
      mine: 'Của tôi',
    },
    card: {
      open: '{count} mở',
      private: 'Dự án riêng tư',
    },
    empty: {
      title: 'Chưa có dự án',
      description: 'Tạo dự án đầu tiên — mã, tên và hồ sơ loại công việc.',
    },
    nothingFound: {
      title: 'Không tìm thấy',
      description: 'Thử từ khoá khác hoặc bỏ bộ lọc.',
    },
    error: {
      title: 'Không tải được danh sách dự án',
      description: 'Dịch vụ không phản hồi. Kiểm tra kết nối và thử lại.',
      retry: 'Thử lại',
    },
    create: {
      action: 'Tạo dự án',
      title: 'Dự án mới',
      key: 'Mã',
      keyPlaceholder: 'DEV',
      name: 'Tên',
      namePlaceholder: 'Phát triển',
      description: 'Mô tả',
      descriptionPlaceholder: 'Dự án nói về gì và ai làm việc trong đó',
      profile: 'Hồ sơ dự án',
      profiles: {
        development: 'Phát triển',
        simple: 'Đơn giản',
      },
      profileHint: {
        development: 'Epic, story, công việc, lỗi, công việc con. Bảng: backlog, cần làm, đang làm, review, kiểm thử, xong.',
        simple: 'Chỉ công việc và công việc con. Bảng: cần làm, đang làm, xong.',
      },
      private: 'Dự án riêng tư',
      privateHint: 'Dự án riêng tư chỉ hiển thị với thành viên của nó.',
      submit: 'Tạo',
      errors: {
        key: 'Chữ Latinh in hoa, từ hai đến mười ký tự',
        failed: 'Không tạo được dự án',
      },
    },
  },
  settings: {
    cancel: 'Bỏ thay đổi',
    save: 'Lưu',
    saved: 'Đã lưu cài đặt',
    saveFailed: 'Không thể lưu cài đặt',
    error: {
      title: 'Không tải được cài đặt',
      description: 'Dịch vụ không phản hồi. Kiểm tra kết nối và thử lại.',
    },
    tabs: {
      columns: 'Cột',
      members: 'Thành viên',
      types: 'Loại công việc',
      general: 'Chung',
    },
    columns: {
      preset: 'Mẫu:',
      presets: {
        COLUMN_PRESET_DEVELOPMENT: 'Phát triển · 6 cột có WIP',
        COLUMN_PRESET_SIMPLE: 'Đơn giản · 3 cột không giới hạn',
      },
      presetLocked: 'Mẫu thay toàn bộ bảng nên chỉ áp dụng cho dự án trống — dự án này đã có công việc.',
      hint: 'Mẫu tạo bộ cột ban đầu. Sau đó có thể sửa: tên, màu, nhóm trạng thái và giới hạn WIP.',
      categories: {
        STATUS_CATEGORY_OPEN: 'Đang mở',
        STATUS_CATEGORY_IN_PROGRESS: 'Đang làm',
        STATUS_CATEGORY_DONE: 'Hoàn thành',
      },
      name: 'Tên cột',
      color: 'Màu cột',
      wip: 'WIP:',
      wipLabel: 'Giới hạn WIP của cột {name}',
      remove: 'Xoá cột {name}',
      add: 'Thêm cột',
      newName: 'Cột mới',
      moveTitle: 'Chuyển công việc đi đâu',
      moveText: 'Cột đang có {count} công việc — chọn nơi chuyển đến.',
      moveTarget: 'Cột đích',
      moveSubmit: 'Xoá cột',
    },
    members: {
      title: 'Thành viên',
      searchPlaceholder: 'Tên hoặc email nhân viên VINPROP',
      role: 'Vai trò',
      add: 'Thêm',
      nobody: 'Không tìm thấy ai',
      noDirectory: 'Không truy cập được danh bạ nhân viên: cần quyền users:read',
      roles: {
        MEMBER_ROLE_ADMIN: 'Quản trị',
        MEMBER_ROLE_MEMBER: 'Thành viên',
        MEMBER_ROLE_VIEWER: 'Người xem',
      },
      hint: 'Quản trị — cài đặt, thành viên và xoá công việc. Thành viên — làm việc với công việc và bảng. Người xem — chỉ đọc. Quyền vào tracker được cấp trong auth.',
    },
    types: {
      profiles: {
        TYPE_PROFILE_DEVELOPMENT: 'Hồ sơ: phát triển',
        TYPE_PROFILE_SIMPLE: 'Hồ sơ: đơn giản',
      },
      hint: 'Bộ loại là cố định: Epic → Story → Task và Bug → Subtask. Hồ sơ bật tắt các loại, không tạo loại riêng.',
      notes: {
        ISSUE_TYPE_EPIC: 'Cấp cao nhất: mục tiêu kéo dài vài tuần, gom story và task',
        ISSUE_TYPE_STORY: 'Giá trị cho người dùng, chia thành các task',
        ISSUE_TYPE_TASK: 'Đơn vị công việc của một người thực hiện',
        ISSUE_TYPE_BUG: 'Lỗi: có màu riêng và mặc định ưu tiên cao',
        ISSUE_TYPE_SUBTASK: 'Danh sách kiểm bên trong công việc, không lên bảng',
      },
      count: '{count} công việc',
    },
    general: {
      name: 'Tên dự án',
      key: 'Khoá',
      keyNote: 'Không đổi được khoá: số hiệu công việc và liên kết nhánh GitLab phụ thuộc vào nó.',
      description: 'Mô tả',
      access: 'Truy cập và quy tắc',
      private: 'Dự án riêng tư',
      privateNote: 'Chỉ thành viên dự án và quản trị viên nhìn thấy',
    },
  },
  editor: {
    mention: {
      empty: 'Không tìm thấy ai',
    },
  },
  app: {
    name: 'VP Tracker',
  },
  login: {
    title: 'Đăng nhập',
    email: 'Email',
    emailPlaceholder: "mk{'@'}vinprop.vn",
    password: 'Mật khẩu',
    passwordPlaceholder: '••••••••••',
    showPassword: 'Hiện mật khẩu',
    hidePassword: 'Ẩn mật khẩu',
    submit: 'Đăng nhập',
    or: 'hoặc',
    google: 'Đăng nhập bằng Google Workspace',
    footer: "Quyền truy cập do quản trị viên VINPROP cấp · vp-adm{'@'}vinprop.vn",
    errors: {
      invalid: 'Email hoặc mật khẩu không đúng',
      unavailable: 'Dịch vụ đăng nhập không khả dụng. Thử lại sau một phút',
    },
  },
  nav: {
    myTasks: 'Việc của tôi',
    projects: 'Dự án',
    calendar: 'Lịch',
    devops: 'DevOps',
    knowledge: 'Cơ sở tri thức',
    projectsOverline: 'Dự án',
    addProject: 'Thêm dự án',
    board: 'Bảng',
    issues: 'Công việc',
    epics: 'Epic',
    projectSettings: 'Cài đặt dự án',
    collapse: 'Thu gọn menu',
    expand: 'Mở rộng menu',
    userMenu: 'Menu người dùng',
  },
  toolbar: {
    search: 'Tìm kiếm…',
    create: 'Tạo mới',
    view: {
      label: 'Chế độ xem dự án',
      board: 'Bảng',
      list: 'Danh sách',
    },
    filters: {
      assignee: 'Người thực hiện',
      type: 'Loại',
      priority: 'Ưu tiên',
      reset: 'Bỏ lọc',
      empty: 'Không có lựa chọn nào',
    },
  },
  views: {
    board: 'Bảng',
    issues: 'Công việc',
    epics: 'Epic',
    calendar: 'Lịch',
    devops: 'DevOps',
    knowledge: 'Cơ sở tri thức',
    myTasks: 'Việc của tôi',
    settings: 'Cài đặt dự án',
    soon: 'Màn hình sẽ có ở các task tiếp theo của epic.',
  },
  errors: {
    forbidden: {
      title: 'Không có quyền vào dự án',
      description: 'Dự án ở chế độ riêng tư. Hãy xin quyền từ quản trị viên dự án.',
    },
    notFound: {
      title: 'Không tìm thấy trang',
      description: 'Hãy kiểm tra địa chỉ: mục có thể đã đổi tên, công việc đã bị chuyển hoặc xoá.',
    },
    back: 'Về việc của tôi',
  },
}
